import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from "../css/Settings.module.css"
import Profile from './Profile';
import Password from './Password';
import Email from './Email';
import { PageContext } from '../../board/js/Notes';
import Loader from '../../Loaders/js/Loader';
import CrashError from '../../Error/js/CrashError';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../../actions/authActions';
import { AUTH_RESET, FETCH_ERROR } from '../../../actions/authTypes';
import { FiSettings, FiX } from 'react-icons/fi';
import useOverflow from '../../../hooks/useOverflow';
import UseMobileLayout from '../../../hooks/useMobileLayout';

const Settings = () => {
    const [tab,setTab] = useState("profile")
    const [,setPageModals] = useContext(PageContext)
    const [loading,setLoading] = useState(true)
    const fetching = useRef(true)
    const dispatch = useDispatch(getProfile())
    const crashError = useSelector((state)=>state.authState.fetchError)
    const contentRef = useRef(null)
    useOverflow(contentRef)
    UseMobileLayout()

    useEffect(()=>{
        if (fetching.current){
            fetching.current = false
            dispatch(getProfile()).finally(()=>setLoading(false))
        }
        return () => {
            dispatch({type: AUTH_RESET})
        }
    },[dispatch])

    const closeModal = () => {
        setPageModals((prevState)=>{
            let copy = {...prevState}
            copy.settings = false
            return copy
        })
    }

    const handleRetry = () => {
        dispatch({type: FETCH_ERROR,payload:false})
        setLoading(true)
        dispatch(getProfile()).finally(()=>setLoading(false))
    }

    return (
    crashError ?
        <CrashError closeMenu = {closeModal} msg = "We’re having trouble fetching your profile. Hang tight and try again." retry={()=>handleRetry()}/> : 
        <div className = {`${styles.wrapper} modal-wrapper`}>
            <div className = {`${styles.innerWrapper} inner-wrapper`}>
                <div className = {`${styles.modal} nested-container`}>
                    <button type = "button" className={styles.close} onClick = {()=>closeModal()}>
                        <FiX/>
                    </button>
                    <div className={styles.header}>
                        <div className={styles.headerIcon}>
                            <FiSettings />
                        </div>
                        <div className={styles.headerText}>
                            <div className={styles.headerTitle}>Settings</div>
                            <div className={styles.headerSub}>
                                Manage your account details and security
                            </div>
                        </div>
                    </div>
                {!loading ?
                <div className = {`${styles.content} nested-container`}>
                    {tab === "profile" && <Profile goToPassword = {()=>setTab("password")} goToEmail = {()=>setTab("email")} />}
                    {tab === "email" && <Email goBack = {()=>setTab("profile")}/>}
                    {tab === "password" && <Password goBack = {()=>setTab("profile")}/>}
                </div>
                : 
                <div className = {styles.loadingArea}>
                    <Loader/>
                </div>}
            </div>
        </div>
    </div>
  )
}

export default Settings